var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.file.success)?_c('div',{staticClass:"text-success font-weight-bold",attrs:{"title":"Uploaded"}},[_vm._v("✓")]):(_vm.file.error)?_c('div',{staticClass:"text-danger font-weight-bold",attrs:{"title":`Error: ${_vm.file.error}`}},[_vm._v("✗")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }